import { render, staticRenderFns } from "./ChatsProgressBar.vue?vue&type=template&id=22839ed1&scoped=true&"
import script from "./ChatsProgressBar.vue?vue&type=script&lang=js&"
export * from "./ChatsProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./ChatsProgressBar.vue?vue&type=style&index=0&id=22839ed1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22839ed1",
  null
  
)

export default component.exports